<div class="back-link">
    <a
        class="back-link__link"
        (click)="back()"
        data-cy="back-link__text">
        <i class="icon icon-angle-left icon-wt back-link__icon"></i>
        {{ text }}
    </a>
</div>
